angular.module('salesPath2')
  .controller('apkTimeoutModalCtrl', ['$scope', 'apkErrorsHelper', 'apkRestSvc', 'sp2UiHelper', 'dataContainerHelper',
    function($scope, apkErrorsHelper, apkRestSvc, sp2UiHelper, dataContainerHelper) {

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.apkTimeoutModal', function() {
          apkErrorsHelper.showApkExternalModal();
        });

        // refresh
        $scope.$on('iHestiaCommonModalCancelBtnClicked.apkTimeoutModal', function() {
          var apk = dataContainerHelper.getApk();
          apkErrorsHelper.getApkDetails({apkid: apk.apkId});
          // sp2UiHelper.showBlockUi();
          // var apk = dataContainerHelper.getApk();
          // apkRestSvc.getApk(apk.apkId, function(response) {
          //   if(response) {
          //     // asd
          //   }
          //   sp2UiHelper.hideBlockUi();
          // }, function() {              
          //   sp2UiHelper.hideBlockUi();
          //   apkErrorsHelper.showApkTimeoutModal();
          // });
        });
      };

      $scope.init();

    }
  ]);
